import { createServerFn } from "@tanstack/react-start";

/** GA measurement IDs are public; never return any other secret to the browser. */
export const getAnalyticsConfig = createServerFn({ method: "GET" }).handler(() => {
  const measurementId = process.env["GOOGLE_ANALYTICS_MEASUREMENT_ID"]?.trim();
  return {
    measurementId: measurementId && /^G-[A-Z0-9]+$/.test(measurementId) ? measurementId : null,
  };
});